'use strict';

goog.provide("Ntry.StudyAiResult");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.StudyAiResult = function() {
    this._view = Ntry.interfaceManager.getDom('ntryResultArea');
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var that = this;
        var parent = this._view;
        var container = Ntry.createElement('div', parent, null, 'ntryResultContainer');
        var title = Ntry.createElement('div', container, null, 'ntryResultTitle')
        this._closeButton = Ntry.createElement('span', title, null, 'ntryResultCloseButton');
        this._closeButton.innerHTML = '닫기';

        var content = Ntry.createElement('div', container, null, 'ntryResultContent');
        this._leftImg = Ntry.createElement('div', content, null, 'ntryResultLeftImg');

        var rightDiv = Ntry.createElement('div', content, null, 'ntryResultRightDiv');
        this._successContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');

        this._usedBlockPrefix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');
        this._usedBlockCnt = Ntry.createElement('span', this._successContent, null, 'ntryResultBlockCnt');
        this._usedBlockSuffix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');

        this._certDiv = Ntry.createElement('div', this._successContent, null, 'ntryResultCertDiv_ai', 'ntryRemove');

        this._certDivLeft = Ntry.createElement('div', this._certDiv, null, 'ntryResultCertDivLeft');

        this._certNameLabel = Ntry.createElement('span', this._certDivLeft, null, 'ntryResultContentNameLabel');
        this._certNameLabel.innerHTML = Lang.Menus.jr_whats_ur_name;

        this._certNameInput = Ntry.createElement('input', this._certDivLeft, null, 'ntryResultContentNameInput_ai');
        this._certNameInput.type = "text";
        this._certNameInput.onkeyup = Ntry.getInputLimitChecker(30);

        this._certLink = Ntry.createElement('div', this._certDiv, null, 'ntryResultContentCert');
        this._certLink.innerHTML = Lang.Menus.jr_down_cert;

        this._failContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');
        this._failCauseString = Ntry.createElement('span', this._failContent, null, 'ntryResultFailCauseSpan');

        this._essentialBlocks = Ntry.createElement('div',this._failContent, null, 'ntryAiResultEssentialBlocks');

        this._replayButton = Ntry.createElement('span', content, null, 'ntryResultReplayButton');
        this._replayButton.innerHTML = Lang.Menus.replay;

        this._nextButton = Ntry.createElement('span', content, null, 'ntryResultNextButton');
        this._nextButton.innerHTML = Lang.Menus.go_to_next_level;
        this._nextButton.bindOnClick(function() {
            Ntry.goToUrl(that._nextLink);
        });
    };

    p.update = function() {};

    p.randomString = function(len) {
        var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
    };

    p.loadConfig = function () {
        Ntry.addEventListener("complete", this, this.complete);
        Ntry.addEventListener("showCert", this, this.showCert);
    };

    p.showCert = function(mode) {
        this._usedBlockCnt.ntryRemove();
        this._failContent.ntryRemove();
        this._replayButton.ntryRemove();
        this._certDiv.ntryShow();
        this._nextButton.ntryRemove();
        this._successContent.ntryShow();
        $(this._certDiv).show();
        $(this._successContent).css('margin-top', '20px');

        this._usedBlockPrefix.innerHTML = "";

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryResultLeftImg');
        this._leftImg.addClass('ntryResultSuccessAi');

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
            $(self._certDiv).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");
            $(self._view).css('display', 'none');
        });

        this._certLink.rebindOnClick(function() {
            var username = self._certNameInput.value;
            if (username === '') {
                alert(Lang.Users.name_not_empty);
                self._certNameInput.focus();
            } else if (Entry.Utils.hasSpecialCharacter(username)) {
                alert("이름에는 특수문자를 사용할 수 없습니다.");
                self._certNameInput.focus();
            } else {
                window.location.href = '/study/maze#!/certificate/'+username +'/'+mode;
            }
        });



        $(this._view).css('display', 'block');
    };

    p.initState = function() {
        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');
    };

    p.complete = function(success, cause) {
        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId)
            stageId = Number(stageId);

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryResultLeftImg');

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");

            $(self._view).css('display', 'none');
        });

        this._nextLink = '/study/maze#!/4/'+(stageId-22+1);

        if (!window.aiuserkey) {
            window.aiuserkey = this.randomString(8);
            $.ajax({
                method: "POST",
                url: "/api/ai/user",
                data: {
                    key: window.aiuserkey
                },
                cache: false
            });
        }

        this._certNameInput.bindOnClick(function() {
            self._certNameInput.focus();
        });

        this._certLink.rebindOnClick(function() {
            var username = self._certNameInput.value;
            if (username === '') {
                alert('이름을 입력하세요.');
                self._certNameInput.focus();
            } else if (Entry.Utils.hasSpecialCharacter(username)) {
                alert("이름에는 특수문자를 사용할 수 없습니다.");
                self._certNameInput.focus();
            } else {
                window.location.href = '/study/maze#!/certificate/'+username +'/4';
            }
        });

        if (success) {
            var isEssentialUsed = this.inspectEssential();
            if (isEssentialUsed || stageId === 32) {
                this.success(stageId, this.getScrollX());
            } else {
                this.fail(stageId, Ntry.STATIC.ESSENTIAL_REQUIRED);
            }
        } else {
            if (stageId === 32 && this.getScrollX() > 0) {
                this.success(stageId, this.getScrollX());
            } else {
                this.fail(stageId, cause);
            }
        }

        $(this._view).css('display', 'block');
    };

    p.inspectEssential = function() {
        var essentialBlock =
            Ntry.configManager.getConfig('essentialBlockInfo');

        if (essentialBlock === undefined) return true;

        var matchCnt = essentialBlock.matchCnt || 1;
        var esBlocks = essentialBlock.blocks.slice(0);

        var code = getUserCode();
        if (_.isEmpty(code)) return false;

        var thread = code.getEventMap('start')[0].getThread();
        if (_.isEmpty(thread)) return false;

        var blocks = thread.getBlockList();

        var index = -1;
        var count = 0;
        for (var i=0; i<blocks.length; i++) {
            index = esBlocks.indexOf(blocks[i].type);
            if (index > -1 && ++count >=matchCnt) {
                esBlocks.splice(i, 1);
                return true;
            }
        }
        return false;
    };

    p.getScrollX = function() {
        if (!this._scroll) {
            var entities = Ntry.entityManager.getEntitiesByComponent(
                Ntry.STATIC.SCROLL
            )
            if (!entities) return 0;
            else {
                var scrollEntity;
                for (var key in entities)
                    this._scroll = Ntry.entityManager.getComponent(
                        key, Ntry.STATIC.SCROLL);
            }
        }
        return Math.floor(this._scroll.scrollX/100);
    };

    p.success = function(stageId, scrollX) {
        this._leftImg.addClass('ntryResultSuccessAi');
        this._replayButton.removeClasses();

        if (stageId === 32) {
            if (scrollX >= 95) {
                this._usedBlockCnt.ntryRemove();
                this._usedBlockPrefix.ntryRemove();
                this._usedBlockSuffix.innerHTML = Lang.Menus.ai_success_msg_1;
            } else {
                this._usedBlockCnt.innerHTML = scrollX;
                this._usedBlockPrefix.innerHTML = Lang.Menus.ai_success_msg_2;
                this._usedBlockSuffix.innerHTML = Lang.Menus.ai_success_msg_3;
            }
            this._replayButton.addClass("ntryResultReplayButtonFailed");
            this._certDiv.ntryShow();
            this._nextButton.ntryRemove();
        } else {
            var blockCnt = this.currentUsedBlock();;
            this._usedBlockPrefix.innerHTML = Lang.Menus.ai_success_msg_4;
            var prefix = 'succeeded_using_';
            var suffix = 'blocks';
            if (Entry.mainWorkspace.getMode() === Entry.Workspace.MODE_VIMBOARD) {
                suffix = 'commands';
                blockCnt--;
            }
            this._usedBlockCnt.innerHTML = blockCnt;
            this._usedBlockSuffix.innerHTML = Lang.Menus[prefix + suffix];
            this._replayButton.addClass('ntryResultReplayButton');
            this._nextButton.ntryShow();
        }

        this._successContent.ntryShow();
        this._failContent.ntryRemove();

        Ntry.dispatchEvent('saveLogs', 'finish');
    };

    function getUserCode() {
        var entities = Ntry.entityManager.
                getEntitiesByComponent(Ntry.STATIC.CODE);

        var entity = entities[Object.keys(entities)[0]];

        if (entity)
            return Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.CODE).code;
    };

    p.currentUsedBlock = function() {
        var code = getUserCode();

        if (code)
            return code.getEventMap('start')[0]
                .getThread().getBlockList(true).length;
    };

    p.fail = function(stageId, cause) {
        var causeString = '';
        var causeStyle = 1;

        var causeMsgs = [
            Lang.Menus.ai_cause_msg_1,
            Lang.Menus.ai_cause_msg_2,
            Lang.Menus.ai_cause_msg_3,
            Lang.Menus.ai_cause_msg_4
        ]

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.ntryRemove();
        switch (cause) {
            case Ntry.STATIC.SIMOOROOK:
                causeString = causeMsgs[0];
                causeStyle = 1;
                break;

            case Ntry.STATIC.COLLISION:
                causeString = causeMsgs[1];
                causeStyle = 2;
                break;

            case Ntry.STATIC.LOST:
                causeString = causeMsgs[2];
                causeStyle = 3;
                break;
            case Ntry.STATIC.ESSENTIAL_REQUIRED:

                causeString = causeMsgs[3];
                causeStyle = 4;
                this.renderBlocks(stageId);
                break;
        }

        var imageClass = 'ntryResultFail_ai_'+ causeStyle;

        this._leftImg.addClass(imageClass);
        this._failCauseString.innerHTML = causeString;

        this._successContent.ntryRemove();
        this._failContent.ntryShow();

        this._nextButton.ntryRemove();
        this._replayButton.removeClasses();
        this._replayButton.addClass("ntryResultFailAndReply");
    };

    p.renderBlocks = function(stageId) {
        var type = 1;

        if (stageId == 24) type = 2;
        else if (stageId >= 25 && stageId <= 30) type = 3;

        var dom = this._essentialBlocks;
        dom.removeClasses();
        dom.addClass("ntryAiResultEssentialBlocks");
        dom.addClass("ntryAiResultEssentialBlocks_" + type);
    }
})(Ntry.StudyAiResult.prototype);
